import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicorporatecabservice() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Corporate Cab Services',
    heading: 'Aaryan Travels: Pune to Mumbai Corporate Cab Services',
    headingDescription: ' Aaryan Travels provides reliable Pune to Mumbai Corporate Cab Services designed for business professionals, executives, and corporate groups who require punctual and premium travel between the two major cities. Whether it’s airport transfers, client meetings, factory visits, or multi-city office travel, our fleet of sedans, SUVs, and luxury cabs ensures a comfortable and productive journey. With uniformed chauffeurs, GPS-enabled vehicles, Wi-Fi on request, and assured punctuality, we offer a seamless intercity travel experience tailored to corporate standards. Pickup is available from any business hub in Pune—Hinjewadi, Kharadi, Magarpatta, or Pimpri-Chinchwad—with direct drop to BKC, Andheri, Navi Mumbai, or Mumbai Airport. Choose Aaryan Travels for safe, professional, and dependable corporate cab services from Pune to Mumbai.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 to commemorate the visit of King George V and Queen Mary, the Gateway of India is Mumbai’s most iconic landmark overlooking the Arabian Sea. Tourists enjoy ferry rides to Elephanta Caves and scenic sunsets from the promenade. The grand Indo-Saracenic architecture stands as a colonial-era symbol of pride. Surrounded by bustling streets and vendors, it remains a favourite photo spot. The Gateway of India is Mumbai’s majestic coastal monument."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen's Necklace, is a 3.6 km-long boulevard curving along Mumbai’s coastline. At night, the streetlights form a dazzling necklace shape across the bay. Locals come here for evening walks, roadside chai, and sea breeze relaxation. Couples and joggers gather daily to enjoy the peaceful ambiance. Marine Drive is Mumbai’s iconic sunset spot."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, CST is an architectural masterpiece built in 1887 in Victorian Gothic Revival style. Its stained-glass windows, domes, and turrets resemble a grand palace. It is one of India’s busiest railway stations, blending function with history. Illuminated at night, it becomes a visual spectacle. CST is Mumbai’s living monument of colonial grandeur."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered 15th-century mosque and tomb located on a small islet in the Arabian Sea. Accessible only via a narrow causeway during low tide, it welcomes devotees of all faiths. The white marble structure appears to float on water, creating a dreamy atmosphere. Qawwali music adds to the spiritual charm. Haji Ali is Mumbai’s symbol of faith and unity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are rock-cut cave temples dedicated to Lord Shiva dating back to the 5th century. The intricate sculptures, including the famous three-faced Trimurti, reflect ancient Indian craftsmanship. Visitors reach the site via a ferry from the Gateway of India. Surrounded by lush greenery and ancient mystique, it offers a journey into history. Elephanta Caves are Mumbai’s timeless heritage treasure."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered shrines dedicated to Lord Ganesha. Devotees, including celebrities and politicians, visit regularly seeking blessings. The gold-plated dome and divine idol create an aura of sanctity. Long queues form daily, especially on Tuesdays. Siddhivinayak is Mumbai’s spiritual powerhouse of devotion."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular seaside hangout known for its lively atmosphere and iconic street food like pav bhaji, bhel puri, and kulfi. Families enjoy sunsets, camel rides, and local performances. Nearby luxury hotels and celebrity homes add glamour. Weekend crowds make it a vibrant social hub. Juhu Beach is Mumbai’s classic leisure escape."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling shopping and café street known for its quirky fashion stalls, antique shops, and iconic eateries like Café Mondegar and Leopold Café. Tourists buy souvenirs, jewelry, and handicrafts at bargain prices. The colonial charm and vibrant street life make it a cultural hotspot. Colaba Causeway is Mumbai’s shopper’s paradise."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world's largest urban national parks, offering lush forests, wildlife safaris, and the ancient Kanheri Caves. Visitors enjoy cycling, trekking, and toy train rides amidst nature. It is known for spotting deer, leopards, and exotic birds. Just minutes away from skyscrapers, it offers a refreshing escape. SGNP is Mumbai’s green lung of biodiversity."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed engineering marvel connecting South Mumbai to the western suburbs. Its illuminated structure over the Arabian Sea looks spectacular at night. Driving across offers stunning skyline views. It reduces travel time while enhancing the city’s modern identity. The Sea Link is Mumbai’s futuristic landmark of progress."
  }
],


"services": [
  {
    "name": "Pune to Mumbai Corporate Cab Services",
    "description": "Our Pune to Mumbai Corporate Cab Services are tailored for businesses looking for reliable, punctual, and executive-grade transportation between the two cities. We offer premium sedans, SUVs, and luxury cars driven by trained chauffeurs. Whether it's for board meetings, airport transfers, or executive travel, our cabs ensure a smooth, quiet, and professional ride with GPS tracking, corporate invoicing, and 24/7 support."
  },
  {
    "name": "Corporate Taxi Pune to Mumbai",
    "description": "The Corporate Taxi service from Pune to Mumbai is perfect for transporting clients, employees, or executives between offices or industrial hubs. Our service includes clean, comfortable AC taxis, professional drivers, on-time performance, and customizable packages for both one-way and round-trip needs. Designed for business-class travel, our taxis deliver efficiency, safety, and convenience."
  },
  {
    "name": "Executive Cab Pune to Mumbai",
    "description": "Our Executive Cab service from Pune to Mumbai offers luxurious and private transport for top-level professionals. Featuring high-end sedans with plush interiors and skilled chauffeurs, this service is ideal for C-suite executives, business travelers, and VIP clients. Quiet cabins, bottled water, and smooth rides create an ideal environment for work or rest during transit."
  },
  {
    "name": "Business Travel Cab Pune Mumbai",
    "description": "Designed for seamless intercity business travel, our Business Travel Cab from Pune to Mumbai ensures maximum efficiency and comfort. With punctual pickups, reliable vehicles, and centralized billing, your employees or guests can travel worry-free between the two cities. We also offer multi-stop options for meetings or site visits en route."
  },
  {
    "name": "Chauffeur Corporate Cab Pune to Mumbai",
    "description": "Enjoy premium service with our Chauffeur-Driven Corporate Cab from Pune to Mumbai. Our drivers are trained in etiquette and route optimization, ensuring a professional travel experience. Ideal for executives, board members, or corporate guests, this service includes luggage assistance, privacy, and real-time support for any changes in plans."
  },
  {
    "name": "Premium Corporate Taxi Pune to Mumbai",
    "description": "Choose our Premium Corporate Taxi service from Pune to Mumbai for an elevated travel experience. With top-end vehicles, leather interiors, and quiet rides, it's perfect for high-stakes meetings and executive travel. Clients also benefit from priority support, dedicated account managers, and complete billing transparency."
  },
  {
    "name": "Affordable Business Cab Pune Mumbai",
    "description": "Get dependable travel between Pune and Mumbai at a budget-friendly rate with our Affordable Business Cab service. Ideal for startups and SMEs, this package offers clean, reliable vehicles and experienced drivers at competitive pricing—without compromising on professionalism or punctuality."
  },
  {
    "name": "Pune to Mumbai Staff Transport",
    "description": "Transport your employees between Pune and Mumbai safely with our Staff Transport service. We provide well-maintained cabs, multi-seat vehicles, and shift-based scheduling to ensure your staff travels comfortably. This service includes GPS tracking, safety protocols, and driver verification—perfect for factories, BPOs, and corporate teams."
  },
  {
    "name": "Monthly Corporate Cab Pune Mumbai",
    "description": "Our Monthly Corporate Cab service between Pune and Mumbai is ideal for businesses with frequent intercity travel needs. Enjoy fixed pricing, dedicated vehicles, and flexible route scheduling. It’s the perfect solution for long-term requirements like weekly meetings, regular client visits, or ongoing employee shuttles."
  },
  {
    "name": "Online Booking Pune to Mumbai Cab",
    "description": "Easily book corporate cabs online for travel between Pune and Mumbai. Our platform allows HRs, managers, and admins to manage bookings, generate reports, and schedule rides in advance. Enjoy fast confirmations, digital receipts, and round-the-clock customer support for all your intercity business travel needs."
  },
  {
    "name": "Office Cab Hire Pune to Mumbai",
    "description": "Hire office cabs between Pune and Mumbai for meetings, team travel, or employee transfers. Our service supports single and group bookings, custom pickup/drop routes, and dedicated driver assignments. It’s the ideal choice for firms looking to scale intercity mobility without managing individual rides."
  },
  {
    "name": "Intercity Corporate Cab Pune to Mumbai",
    "description": "Our Intercity Corporate Cab service from Pune to Mumbai delivers smooth, safe, and punctual rides for all business purposes. Be it client transfers, plant visits, or inter-office connectivity, our fleet of sedans and SUVs ensures your corporate mobility needs are covered with consistency and quality."
  },
  {
    "name": "Pune to Mumbai Sedan Cab",
    "description": "Travel in comfort and class with our Sedan Cabs from Pune to Mumbai. Ideal for business professionals, these vehicles offer spacious interiors, air conditioning, and smooth rides for a productive or relaxing journey. Our sedans come with trained drivers and are perfect for one-way or round-trip travel."
  },
  {
    "name": "Pune to Mumbai SUV Rental",
    "description": "Our SUV Rental from Pune to Mumbai is ideal for corporate groups, executives with extra luggage, or long-distance comfort seekers. Featuring premium models like Innova Crysta, we provide spacious, clean, and high-performance SUVs with professional chauffeurs and flexible billing plans."
  },
  {
    "name": "Fast Business Cab Pune to Mumbai",
    "description": "Need urgent travel between Pune and Mumbai? Our Fast Business Cab service offers quick dispatch, priority support, and route-optimized rides to minimize travel time. Best suited for last-minute meetings, emergency visits, or unscheduled trips, this service ensures reliability with no delays."
  }
],
"tableData": [
  ["Pune to Mumbai Corporate Cab Services", "Corporate Taxi Pune to Mumbai"],
  ["Executive Cab Pune to Mumbai", "Business Travel Cab Pune Mumbai"],
  ["Chauffeur Corporate Cab Pune to Mumbai", "Premium Corporate Taxi Pune to Mumbai"],
  ["Affordable Business Cab Pune Mumbai", "Pune to Mumbai Staff Transport"],
  ["Monthly Corporate Cab Pune Mumbai", "Online Booking Pune to Mumbai Cab"],
  ["Office Cab Hire Pune to Mumbai", "Intercity Corporate Cab Pune to Mumbai"],
  ["Pune to Mumbai Sedan Cab", "Pune to Mumbai SUV Rental"],
  ["Fast Business Cab Pune to Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Services from Pune to Mumbai",
    "WhyChoosedescription": "Aaryan Travels provides professional and punctual cab services for corporate travel between Pune and Mumbai."
  },
  {
    "WhyChooseheading": "Timely Pickup from Offices and Business Hubs in Pune",
    "WhyChoosedescription": "We ensure on-time pickups from your office, hotel, or preferred location in Pune for a seamless journey to Mumbai."
  },
  {
    "WhyChooseheading": "Executive-Class Vehicles for Comfortable Travel",
    "WhyChoosedescription": "Travel in clean, air-conditioned sedans, SUVs, or premium cars perfect for business travel and meetings on the go."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Expressway Travel",
    "WhyChoosedescription": "Our trained chauffeurs are well-versed with the Mumbai-Pune Expressway for a safe and efficient ride."
  },
  {
    "WhyChooseheading": "Transparent Pricing with GST-Compliant Invoices",
    "WhyChoosedescription": "Enjoy upfront, all-inclusive pricing with no hidden charges—ideal for corporate accounting and reimbursements."
  },
  {
    "WhyChooseheading": "24/7 Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with scheduling, changes, and bookings."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for One-Way, Round Trip & Same-Day Return",
    "WhyChoosedescription": "Customize your travel as per your business schedule with multiple booking options."
  },
  {
    "WhyChooseheading": "Fleet Suitable for Individuals, Teams, and VIP Travel",
    "WhyChoosedescription": "Choose from a wide range of vehicles including sedans, SUVs, and luxury cars based on your corporate needs."
  }
]





















  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide corporate cab services from Pune to Mumbai?',
    answer: 'Yes, Aaryan Travels offers reliable and professional corporate cab services for travel from Pune to Mumbai.',
  },
  {
    question: 'How can I book a corporate cab from Pune to Mumbai with Aaryan Travels?',
    answer: 'You can book your corporate cab through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab travel from Pune to Mumbai?',
    answer: 'We offer a fleet of sedans, SUVs, and premium cars ideal for executive travel and team transportation.',
  },
  {
    question: 'Are Pune to Mumbai corporate cab services available for one-way and round trips?',
    answer: 'Yes, Aaryan Travels provides both one-way and round-trip corporate cab services between Pune and Mumbai.',
  },
  {
    question: 'Are the drivers trained and experienced for corporate travel between Pune and Mumbai?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and experienced on the Pune-Mumbai route.',
  },
  {
    question: 'Can Aaryan Travels manage bulk or group cab bookings for corporate events in Mumbai?',
    answer: 'Yes, we specialize in handling group and bulk cab bookings for conferences, meetings, and events in Mumbai.',
  },
  {
    question: 'Do you offer monthly billing and invoicing for Pune to Mumbai corporate cab services?',
    answer: 'Yes, we provide flexible monthly billing options and GST-compliant invoices for corporate clients.',
  },
  {
    question: 'Is the Pune to Mumbai corporate cab service available 24x7?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services from Pune to Mumbai for your convenience.',
  },
  {
    question: 'What safety protocols are followed for corporate cab travel between Pune and Mumbai?',
    answer: 'All vehicles are sanitized regularly and our drivers follow strict safety and hygiene guidelines.',
  },
  {
    question: 'Can pickup and drop-off points be customized for Pune to Mumbai corporate cab bookings?',
    answer: 'Yes, we offer complete flexibility in choosing pickup and drop-off locations to meet your corporate travel needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harshad Malhotra',
    feedback: 'Aaryan Travels made our Pune to Mumbai corporate travel seamless and stress-free. Highly professional service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meenal Shah',
    feedback: 'Very reliable corporate cab service for our executive team’s Pune to Mumbai travel. Great experience with Aaryan Travels.',
    rating: 5,
  },
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Corporate Cab Services",
  "image": "https://aaryantravels.com/assets/images/pune-mumbai-corporate-cab.jpg", // replace with actual image URL
  "description": "Professional and affordable corporate cab services from Pune to Mumbai by Aaryan Travels. Ideal for business travel, staff transport, and executive rides with sedan and SUV options. Book online for reliable corporate cab hire.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // example rating, update as needed
    "ratingCount": "3800", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/pune-to-mumbai-corporate-cab-services"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Corporate Cab Services | Executive Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Professional and affordable corporate cab services from Pune to Mumbai by Aaryan Travels. Ideal for business travel, staff transport, and executive rides with sedan and SUV options. Book online for reliable corporate cab hire."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Corporate Cab Services, Corporate Taxi Pune to Mumbai, Executive Cab Pune to Mumbai, Business Travel Cab Pune Mumbai, Chauffeur Corporate Cab Pune to Mumbai, Premium Corporate Taxi Pune to Mumbai, Affordable Business Cab Pune Mumbai, Pune to Mumbai Staff Transport, Monthly Corporate Cab Pune Mumbai, Online Booking Pune to Mumbai Cab, Office Cab Hire Pune to Mumbai, Intercity Corporate Cab Pune to Mumbai, Pune to Mumbai Sedan Cab, Pune to Mumbai SUV Rental, Fast Business Cab Pune to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaicorporatecabservice;